function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
import { isPxOrPercentage } from './utils';
import SubMixin from './mixins/sub';
import ColGroup from './colGroup.js';
import TableHeader from './tableHeader';
import TableBody from './tableBody';
var __vue_script__ = {
  name: 'BasicTable',
  components: {
    ColGroup: ColGroup,
    TableHeader: TableHeader,
    TableBody: TableBody
  },
  mixins: [SubMixin],
  props: {
    hasHead: {
      type: Boolean,
      default: false
    },
    hasBody: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes: function classes() {
      var prefixCls = this.prefixCls,
          fixed = this.fixed,
          scroll = this.scroll;
      return _defineProperty({}, "".concat(prefixCls, "-fixed"), fixed || scroll.x);
    },
    style: function () {
      var fixed = this.fixed,
          scroll = this.scroll;
      var style = {};

      if (!fixed && scroll.x) {
        style.tableLayout = 'fixed';

        if (typeof scroll.x === 'boolean') {
          style.width = '100%';
        } else {
          style.width = isPxOrPercentage(scroll.x) ? scroll.x : "".concat(scroll.x, "px");
        }
      }

      return style;
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('table', {
    class: _vm.classes,
    style: _vm.style
  }, [_c('col-group', {
    attrs: {
      "fixed": _vm.fixed
    }
  }), _vm.hasHead ? _c('table-header', {
    attrs: {
      "fixed": _vm.fixed
    }
  }) : _vm._e(), _vm.hasBody ? _c('table-body', {
    attrs: {
      "fixed": _vm.fixed
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "baseTable.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);